/**
 * Collection Filters
 * Client-side filtering of product grid by collection membership.
 * Two filter groups that cumulate (AND between groups, OR within a group).
 */
(function () {
  function getCheckedHandles(group) {
    const checked = [];
    document
      .querySelectorAll(`.collection-filter-checkbox[data-filter-group="${group}"]:checked`)
      .forEach((cb) => checked.push(cb.dataset.collectionHandle));
    return checked;
  }

  function applyFilters() {
    const group1 = getCheckedHandles('1');
    const group2 = getCheckedHandles('2');
    const hasGroup1 = group1.length > 0;
    const hasGroup2 = group2.length > 0;

    const items = document.querySelectorAll('#ProductGridContainer .grid__item[data-collections]');
    let visibleCount = 0;

    items.forEach((item) => {
      const productCollections = item.dataset.collections.split(',').map((h) => h.trim());

      let matchGroup1 = !hasGroup1 || group1.some((h) => productCollections.includes(h));
      let matchGroup2 = !hasGroup2 || group2.some((h) => productCollections.includes(h));

      if (matchGroup1 && matchGroup2) {
        item.style.display = '';
        visibleCount++;
      } else {
        item.style.display = 'none';
      }
    });

    // Update product count displays
    const countEl = document.getElementById('ProductCount');
    const countDesktopEl = document.getElementById('ProductCountDesktop');
    if (hasGroup1 || hasGroup2) {
      const countText = visibleCount === 1 ? visibleCount + ' produit' : visibleCount + ' produits';
      if (countEl) countEl.textContent = countText;
      if (countDesktopEl) countDesktopEl.textContent = countText;
    }
  }

  function init() {
    // Stop collection filter checkboxes from triggering native Shopify facet AJAX
    document.addEventListener(
      'input',
      (e) => {
        if (e.target.classList.contains('collection-filter-checkbox')) {
          e.stopPropagation();
        }
      },
      true,
    );

    document.addEventListener(
      'change',
      (e) => {
        if (e.target.classList.contains('collection-filter-checkbox')) {
          e.stopPropagation();
          applyFilters();
        }
      },
      true,
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
